import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/logoBig.png';
import _imports_1 from '@/assets/img/tuichu.png';
const _withScopeId = n => (_pushScopeId("data-v-ba57a02e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "",
  style: {
    "height": "100%"
  }
};
const _hoisted_2 = {
  class: "flex-inner"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", null, "泰戈智慧物联管理平台")], -1));
const _hoisted_4 = {
  class: "avatar-uploader-wrapper"
};
const _hoisted_5 = {
  class: "username"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  class: "right-flex"
};
const _hoisted_8 = {
  class: "time"
};
const _hoisted_9 = {
  class: "date"
};
const _hoisted_10 = {
  class: "time-text"
};
const _hoisted_11 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_12 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EIUploadOnePic = _resolveComponent("EIUploadOnePic");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_Screenfull = _resolveComponent("Screenfull");
  const _component_sidebar = _resolveComponent("sidebar");
  const _component_app_main = _resolveComponent("app-main");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass([$options.classObj, "app-wrapper"])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["main-container", {
      hasTagsView: _ctx.needTagsView
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(["fixed-header", {
      'home-header': !$options.showSideBar
    }])
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_EIUploadOnePic, {
    "file-list": $data.avatarFileList,
    "onUpdate:fileList": [_cache[0] || (_cache[0] = $event => $data.avatarFileList = $event), $options.handleAvatarFileListUpdate],
    type: "image"
  }, null, 8, ["file-list", "onUpdate:fileList"])]), _createElementVNode("span", _hoisted_5, "您好，欢迎" + _toDisplayString(_ctx.userInfo.nickname) + "登录系统 |", 1), _ctx.tenantInfos.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives(_createVNode(_component_el_select, {
    placeholder: "切换租户",
    modelValue: $data.tenantId,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.tenantId = $event),
    onChange: $options.changeTenantId,
    clearable: _ctx.userInfo.userType == 3,
    class: "tenant-select",
    style: _normalizeStyle({
      width: $data.tenantSelectWidth + 'px'
    })
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantInfos, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.tenantId,
        label: item.tenantName,
        value: item.tenantId
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onChange", "clearable", "style"]), [[_vShow, _ctx.tenantInfos.length > 1]]), _withDirectives(_createElementVNode("span", {
    class: "username"
  }, _toDisplayString(_ctx.tenantInfos[0].tenantName), 513), [[_vShow, _ctx.tenantInfos.length == 1]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.currentDate), 1), _createElementVNode("div", _hoisted_10, _toDisplayString($data.currentTime), 1)]), _createVNode(_component_Screenfull, {
    class: "screenfull-btn"
  }), _createElementVNode("img", {
    src: _imports_1,
    alt: "",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.logout && $options.logout(...args)),
    class: "logoutBtn"
  })])], 2), _createElementVNode("div", {
    class: _normalizeClass(["flex-box", {
      'main-one': $options.showSideBar
    }])
  }, [$options.showSideBar ? (_openBlock(), _createBlock(_component_sidebar, {
    key: 0,
    class: "sidebar-container"
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [$options.currentIframe ? (_openBlock(), _createElementBlock("iframe", {
    key: 0,
    allowfullscreen: "true",
    ref: "iframe",
    style: _normalizeStyle($options.iframeStyle),
    src: $options.currentIframe.src
  }, null, 12, _hoisted_12)) : (_openBlock(), _createBlock(_component_app_main, {
    key: 1
  }))])], 2)], 2)])], 2);
}